import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  text,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      // Fire Meta Pixel AddToCart event
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (onClick) {
      onClick();
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`group relative inline-flex items-center justify-center gap-3 rounded-full bg-[#D4603A] px-8 py-4 text-lg font-semibold text-white shadow-lg transition-shadow hover:shadow-[#D4603A]/30 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#D4603A] focus:ring-offset-2 focus:ring-offset-[#FBF7F0] ${className}`} data-id="element-37">
      <span className="font-sans tracking-wide" data-id="element-38">{text}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-39" />
    </motion.button>;
}